/* eslint-disable lingui/no-unlocalized-strings -- Hostnames and URLs, not UI copy. */

import { FIRST_ROUND_ORIGIN } from "./firstRoundAppUrl";

// The theresume.io hub is the front door for both products, so its product CTAs always point to
// the public brand domains. This keeps the landing page behavior consistent in local previews,
// staging, and production.
export const APEX25_ORIGIN = "https://tryapex25.com";
const RECRUIT_PRODUCTION_ORIGIN = "https://recruit.theresume.io";
const RECRUIT_STAGING_ORIGIN = "https://recruit.staging.theresume.io";

const currentHostname = () => (typeof window === "undefined" ? "" : window.location.hostname);

const isProductionHost = (hostname: string) => hostname === "theresume.io";

/** Public First Round home used by landing-page CTAs. */
export const firstRoundPublicUrl = () => `${FIRST_ROUND_ORIGIN}/`;

// Keep the original hub helper name available to callers while the destination is now always the
// public First Round domain.
export const firstRoundHomeUrl = firstRoundPublicUrl;

/** Public Apex 25 home used by landing-page CTAs. */
export const apex25HomeUrl = (_hostname?: string) => `${APEX25_ORIGIN}/`;

/** theRecruit's sign-in page, for hiring teams who already have an account. */
export const recruiterSignInUrl = (hostname = currentHostname()) =>
  `${isProductionHost(hostname) ? RECRUIT_PRODUCTION_ORIGIN : RECRUIT_STAGING_ORIGIN}/sign-in`;

/**
 * A job seeker's tool: straight into the workspace when signed in, otherwise through sign-up and
 * back to the same page.
 */
export const candidateToolUrl = (dashboardPath: string, signedIn: boolean) =>
  signedIn ? dashboardPath : `/auth/register?redirect=${dashboardPath}`;
